import mastercardIcon from "assets/payment-methods/mastercard.svg"
import paypalIcon from "assets/payment-methods/paypal.svg"
import visaIcon from "assets/payment-methods/visa.svg"
import { LogoData } from "src/components/(checkout)/cart/components/Logos"

export const paymentMethodLogos: LogoData[] = [
  { name: "PayPal", icon: paypalIcon.src },
  { name: "Mastercard", icon: mastercardIcon.src },
  { name: "Visa", icon: visaIcon.src },
  // { name: "Klarna", icon: klarnaIcon.src, background: "#ffb3c7" },
]

const de = {
  securePayment: "Sicher bezahlen",
}

const en: typeof de = {
  securePayment: "Secure payment",
}

export const paymentMethodText = { de, en }
